export * from './endpoints';
import { generatedAPI } from './endpoints';

export const announcementBannerAPI = generatedAPI.enhanceEndpoints({});
